(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jobs-posts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const programmeFilter = document.getElementById('programmeFilter');
    const roleFilter = document.getElementById('roleFilter');
    const countyFilter = document.getElementById('countyFilter');
    const clearButton = document.getElementById('clearJobFilters');
    const noResults = document.getElementById('jobsNoResults');
    const summary = document.getElementById('jobsFilterSummary');
    const resultsCount = document.getElementById('jobsResultsCount');

    if (!programmeFilter || !roleFilter || !countyFilter) return;

    const cards = Array.from(document.querySelectorAll('.pha__jobs-grid-item'));
    const jobArticles = cards
      .map(function (card) {
        return {
          card: card,
          article: card.querySelector('.pha__jobs-grid-item-row')
        };
      })
      .filter(function (item) {
        return item.article;
      });

    function normalise(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    function hasActiveFilters() {
      return (
        normalise(programmeFilter.value) !== '' ||
        normalise(roleFilter.value) !== '' ||
        normalise(countyFilter.value) !== ''
      );
    }

    function updateSummary(visibleCount) {
      if (!summary || !resultsCount) return;

      if (hasActiveFilters()) {
        resultsCount.textContent = visibleCount === 1
          ? '1 job found'
          : visibleCount + ' jobs found';
        summary.style.display = '';
      } else {
        summary.style.display = 'none';
      }
    }

    function applyFilters() {
      const selectedProgramme = normalise(programmeFilter.value);
      const selectedRole = normalise(roleFilter.value);
      const selectedCounty = normalise(countyFilter.value);

      let visibleCount = 0;

      jobArticles.forEach(function (item) {
        const programme = normalise(item.article.dataset.programme);
        const role = normalise(item.article.dataset.role);
        const county = normalise(item.article.dataset.county);

        const programmeMatch = !selectedProgramme || programme === selectedProgramme;
        const roleMatch = !selectedRole || role === selectedRole;
        const countyMatch = !selectedCounty || county === selectedCounty;

        const matches = programmeMatch && roleMatch && countyMatch;

        item.card.style.display = matches ? '' : 'none';

        if (matches) visibleCount++;
      });

      if (noResults) {
        noResults.style.display = visibleCount === 0 ? '' : 'none';
      }

      updateSummary(visibleCount);
    }

    programmeFilter.addEventListener('change', applyFilters);
    roleFilter.addEventListener('change', applyFilters);
    countyFilter.addEventListener('change', applyFilters);

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        programmeFilter.value = '';
        roleFilter.value = '';
        countyFilter.value = '';
        applyFilters();
      });
    }

    applyFilters();
  });

  } catch(e) { console.error(e); }
})();
})();
